// Single source of truth for the product name shown to people. Code identifiers
// (Aone* components, aone-* CSS classes, module ids) keep the short form on purpose.
export const APP_NAME = 'Celebration Kraft';
export const BOT_NAME = `${APP_NAME} Bot`;
